/** Shared rules for portal uploads (feedback + item request). */

export const MAX_ATTACHMENT_BYTES = 500 * 1024

export const ACCEPT_ATTACHMENT_ATTR =
  'image/jpeg,image/png,application/pdf,.jpg,.jpeg,.png,.pdf'

export function isAllowedAttachmentFile(f: File): boolean {
  if (/\.(jpe?g|png|pdf)$/i.test(f.name)) return true
  return ['image/jpeg', 'image/png', 'application/pdf'].includes(f.type)
}
